import React from 'react'
import { Link } from 'app/common/link'
import styled from 'styled-components'
import { ResponsiveContainer } from 'app/assets/styles'
import { colors } from 'shared/assets/styles'
import { H6 } from 'app/common/typography'
import { CircleChevron } from 'app/assets/icons'
import type { MarketingAnimationShortDTO } from 'shared/types'
import { eventsDefinitions } from 'shared/store/metadata'

const FooterNotice = (props: MarketingAnimationShortDTO) => {
    const { actionLabel, actionUrl } = props
    const meta = eventsDefinitions['FOOTER_NOTICE']
    return (
        <Story>
            <ResponsiveContainer>
                <StyledLink url={actionUrl} meta={meta}>
                    <StyledH6 color={'white'}>{actionLabel}</StyledH6>
                    <StyledChevron background={colors.red} />
                </StyledLink>
            </ResponsiveContainer>
        </Story>
    )
}

const Story = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: ${colors.red2};
`

const StyledLink = styled(Link)`
    display: flex;
    align-items: center;
    justify-content: center;
`

const StyledH6 = styled(H6)`
    margin: 24px 0;
`

const StyledChevron = styled(CircleChevron)`
    margin-left: 30px;
    flex-shrink: 0;
`

export { FooterNotice }
